import React from "react";
import useContact from "./useContact";
import { predefinedIcons } from "./utils/contactData";

function ListContacts() {
  const { contactData, isLoadingContacts } = useContact();

  // Function to get icon component
  const getIconComponent = (type) => {
    const iconData = predefinedIcons?.find((icon) => icon.id === type);
    return iconData?.preview || null;
  };

  if (isLoadingContacts) {
    return <div className="text-center py-8">Loading...</div>;
  }

  return (
    <div className="mx-auto p-2">
      <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
        My Contacts
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {contactData?.map((item) => {
          const IconComponent = getIconComponent(item.type);

          return (
            <div
              key={item._id}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden"
            >
              {/* Profile Section */}

              <h2 className="text-xl font-bold text-white mt-3">{item.name}</h2>

              {/* Contact Info */}
              <div className="p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-8 h-8 text-gray-600">{IconComponent}</div>
                  <span className="text-sm font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full capitalize">
                    {item.type}
                  </span>
                </div>

                <a
                  href={item.link}
                  className="block w-full bg-blue-500 hover:bg-blue-600 text-white text-center py-3 px-4 rounded-lg font-medium transition-colors duration-200"
                >
                  Connect <span className="underline">{item.link}</span>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ListContacts;
